import React from "react";
import { MessageCircle } from "lucide-react";
import { trackWhatsAppLead } from "../../utils/ads";
import { buildWhatsAppUrl, openWhatsApp } from "../../utils/whatsapp";

/** Variantes alineadas a los botones del sitio (src/styles.css). */
const VARIANTS = {
  sand: "btn-sand",
  dark: "btn-primary",
  outline: "btn-ghost-light",
  ghost: "btn-ghost",
};

/**
 * CTA a WhatsApp con mensaje preescrito.
 *
 * Es un <a> real (indexable, abrible en nueva pestaña, con menú contextual) y
 * además registra la conversión antes de abrir el chat.
 */
const WhatsAppCta = ({
  message,
  pack,
  location,
  variant = "sand",
  className = "",
  children,
  showIcon = true,
}) => {
  const handleClick = (event) => {
    event.preventDefault();
    trackWhatsAppLead({ location, pack }, () => openWhatsApp(message));
  };

  return (
    <a
      href={buildWhatsAppUrl(message)}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      data-cta={location}
      className={`${VARIANTS[variant] || VARIANTS.sand} ${className}`}
    >
      {showIcon ? <MessageCircle className="h-4 w-4 shrink-0" aria-hidden="true" /> : null}
      {children}
    </a>
  );
};

export default WhatsAppCta;
